import styled from "styled-components";
import logoWhite from "../../assets/CAMRA-logo-white.png"
import Menu from "./Menu";

const StyledHeader = styled.div`
    background-color: ${(props) => props.theme.color.primaryblue};
    height: 60px;
    color: white;
`;

const HeaderBar = styled.div`
    display: flex;
    height: 100%;
    margin: auto;
    width: 1000px;
    padding-left: max(45px, min((100vw - 1000px)/2, 185px));
    padding-right: max(45px, min((100vw - 1000px)/2, 185px));
`;

const LogoAndTitle = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 30px;
    user-select: none;
    min-width: 250px;
    cursor: pointer;
`;

const Logo = styled.img`
    width: 100px;
    height: 45px;
`;

const TitleAndDescription = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    display: flex;
    flex-direction: column;
    padding-left: 16px;
`;

const Title = styled.span`
    font-size: 12px;
    font-weight: bold;
    padding-bottom: 2px;
`;

const Description = styled.span`
    color: ${(props) => props.theme.color.secondaryhover};
    font-size: 10px;
`;

function Header(props) {
    
    const { isLoggedin } = props;

    return <StyledHeader>
        <HeaderBar>
            <LogoAndTitle>
                <Logo src={logoWhite} />
                <TitleAndDescription>
                    <Title>CAMRA Admin</Title>
                    <Description>Online branch accounting system</Description>
                </TitleAndDescription>
            </LogoAndTitle>
            {isLoggedin && <Menu {...props}/>}
        </HeaderBar>
    </StyledHeader>;
}

export default Header;